import { createContext, useState, useContext } from 'react'
import { useCallback } from 'react';
import Logo from '../components/common/Logo';

interface FullScreenLoaderInterface {
  showLoader: () => void;
  hideLoader: () => void;
}

const FullScreenLoaderContext = createContext<FullScreenLoaderInterface>({} as FullScreenLoaderInterface);

export const FullScreenLoaderProvider = ({ children }: React.PropsWithChildren) => {
  const [loading, setLoading] = useState(false);

  const showLoader = useCallback(() => setLoading(true), []);
  const hideLoader = useCallback(() => setLoading(false), []);

  return (
    <FullScreenLoaderContext.Provider value={{ showLoader, hideLoader }}>
      {children}

      {loading && (
        <div className="full-screen-loader">
          <Logo width={350} />
        </div>
      )}
    </FullScreenLoaderContext.Provider>
  )
}

export const useFullScreenLoader = () => useContext(FullScreenLoaderContext);